import { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: 'intro',
    name: 'preview-intro',
    component: () => import('@/views/Survey/IntroPage.vue'),
    meta: {
      name: 'Survey Preview Intro',
      user: true,
      preview: true,
    },
  },
  {
    path: 'survey',
    name: 'preview-survey',
    component: () => import('@/views/Survey/SurveyHome.vue'),
    meta: {
      name: 'Survey Preview',

      user: true,
      preview: true,
      showFooter: true,
      scrollToTop: true,
    },
  },
  {
    path: 'finish',
    name: 'preview-finish',
    component: () => import('@/views/Survey/FinishPage.vue'),
    meta: {
      name: 'Survey Preview Finish',
      user: true,
      preview: true,
      scrollToTop: true,
    },
  },
  {
    path: 'closed',
    name: 'preview-closed',
    component: () => import('@/views/Survey/Closed/ClosedPage.vue'),
    meta: {
      name: 'Survey Preview Closed',
      user: true,
      preview: true,
    },
  },
  {
    path: 'query',
    redirect(to) {
      const { query } = to;
      return {
        name: 'preview-intro',
        hash: `#${new URLSearchParams(query as Record<string, string>).toString()}`,
        query: {},
      };
    },
    meta: {
      participant: true,
      preview: true,
    },
  },
] satisfies RouteRecordRaw[];
